import { useState } from "react";
import { X, Building2, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { mainHref } from "../lib/hosts";

const KEY = "buma:schools-ribbon-dismissed";
const DAYS = 30;

// Slim, dismissible strip shown only on the kids host: points schools & centers to the institutions site.
export function SchoolsRibbon() {
  const { t } = useApp();
  const [hidden, setHidden] = useState(() => { try { return Number(localStorage.getItem(KEY) || 0) > Date.now(); } catch { return false; } });
  if (hidden) return null;
  const dismiss = () => { try { localStorage.setItem(KEY, String(Date.now() + DAYS * 864e5)); } catch { /* ignore */ } setHidden(true); };
  return (
    <div className="bg-slate-900 text-slate-100 text-xs sm:text-sm" data-testid="schools-ribbon">
      <div className="max-w-6xl mx-auto px-4 py-1.5 flex items-center gap-3">
        <Building2 size={14} className="shrink-0 text-amber-300" />
        <span className="truncate">{t("ribbonSchools")}</span>
        <a href={mainHref("/")} data-testid="schools-ribbon-link" className="shrink-0 inline-flex items-center gap-1 font-bold text-amber-300 hover:text-white">{t("ribbonSchoolsCta")} <ArrowRight size={13} className="rtl:rotate-180" /></a>
        <button onClick={dismiss} data-testid="schools-ribbon-dismiss" aria-label="dismiss" className="ms-auto p-1 rounded hover:bg-white/10"><X size={14} /></button>
      </div>
    </div>
  );
}
